import React, { useCallback } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';

import metadata from './MLMinimumUnderlyingLimitModal.metadata.json5';
import './MLMinimumUnderlyingLimitModal.messages';

function MLMinimumUnderlyingLimitModal(){

    const getUnderlyingPolicies = useCallback(() => {
        const limits = '$250,000/$500,000 or $500,000';
        const smallLimits = '$250,000/$500,000 or $300,000';
        const smallLimit = '$300,000';
        return [
            { type: 'Automobile Liability', value: limits },
            { type: 'Automobile Uninsured-Underinsured Motorist Bodily Injury ', value: limits },
            { type: 'Homeowners Liability', value: smallLimit },
            { type: 'Dwelling Fire or Landlord Liability', value: smallLimit },
            { type: 'Watercraft Liability', value: smallLimits },
            { type: 'Recreational Vehicle Liability', value: limits },
            { type: 'Motorcycle Liability', value: limits },
            { type: 'Motorcycle Uninsured-Underinsured Motorists Bodily Injury', value: limits }
        ];
    }, []);

    const overrides = {
        mlMinimumUnderlyingLimitTableRow: {
            data: getUnderlyingPolicies()
        }
    };

    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {}
    };
    
    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLMinimumUnderlyingLimitModal;
